import React from 'react';
import styles from '../Attachment.module.scss';
import { AttachmentNameDisplay } from './GenerticAttachment';
import { IFile } from '../../../../types';
import { useTypedDispatch } from '../../../../redux/hooks';
import { nebulaChatApi } from '../../../../redux/services/nebulaChat';
import { setFilePreview } from '../../../../redux/slices';
import AriaButton from '../../../../components/AriaComponents/AriaButton';
import Icon from '../../../../components/Icon';
import LoadingSpinner from '../../../../components/loading/LoadingSpinner';

interface Props {
    file: IFile;
    showOptions: boolean;
}

export const VideoAttachment: React.FC<Props> = ({ file, showOptions }) => {
    const dispatch = useTypedDispatch();
    const [fetchVideo] = nebulaChatApi.endpoints.pullFileN.useLazyQuery();

    const activatePreview = async () => {
        const result = await fetchVideo({ file_uuid: file.uuid, thumbnail: false });
        if (!result.data) return;
        dispatch(setFilePreview({
            src: result.data,
            file_name: file.name,
            file_type: 'video',
            file_size: file.size,
            shared_by: file.shared_by,
            shared_at: file.shared_at as any,
            uuid: file.uuid,
        }));
    };

    return (
        <>
            <div className={styles.preview_button_container}>
                {file.pending ? (<LoadingSpinner color='mamba' />) : null}
                {!file.pending && showOptions ? (
                    <AriaButton onClick={activatePreview}>
                        <Icon name='playFilled' />
                    </AriaButton>
                ) : null}
                {!file.pending && !showOptions ? (
                    <Icon name='videoFilled' />
                ) : null}
            </div>
            <div className={styles.file_content_container}>
                <AttachmentNameDisplay file={file} />
            </div>
        </>
    );
};
